(function () {
  'use strict';
  // 热区截图管线（playwright addInitScript）注入的标记：抓取访问不产生任何埋点数据。
  // collector 侧 UA 含 IdpCaptureBot 的兜底过滤是第二道防线（防旧版 theme SDK 滞后）。
  if (window.__IDP_CAPTURE__) {
    return;
  }
  var cfg = window.IDP_EVENTS_CONFIG || {};
  var webKey = cfg.webKey || 'BF';
  var endpoint = cfg.endpoint || '/idp/events';
  var experimentEndpoint = cfg.experimentEndpoint || endpoint.replace(/\/events(\?.*)?$/, '/experiments/config?webKey=' + encodeURIComponent(webKey));
  var heartbeatEndpoint = cfg.heartbeatEndpoint || endpoint.replace(/\/events(\?.*)?$/, '/sdk/heartbeat');
  var enabled = cfg.enabled !== false;
  var inspectorAllowedOrigins = cfg.inspectorAllowedOrigins || [
    'https://daily.admin.miaoerp.com',
    'https://admin.miaoerp.com',
    'http://localhost:8000',
    'http://localhost:3000',
    'http://127.0.0.1:8000',
    'http://127.0.0.1:3000'
  ];
  var maxBatchSize = cfg.maxBatchSize || 50;
  var flushIntervalMs = cfg.flushIntervalMs || 30000;
  var heartbeatIntervalMs = cfg.heartbeatIntervalMs || 1800000;
  var sessionTtlMs = cfg.sessionTtlMs || 1800000;
  var deadLetterKey = 'idp_events_deadletter_' + webKey;
  var deviceKey = 'idp_device_id_' + webKey;
  var sessionKey = 'idp_session_id_' + webKey;
  var expConfigKey = 'idp_exp_config_' + webKey;
  var expConfigTtlMs = 3600000;
  var queue = [];
  var scrollSent = {};
  var experimentConfig = null;
  var pageStartedAt = Date.now();
  var lastPageUrl = location.href;
  var flushTimer = null;
  var lastHeartbeatAt = 0;
  var deadLetterDropped = 0;
  function storageGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (e) {
      return null;
    }
  }
  function storageSet(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (e) {
      // ignore storage quota / privacy mode
    }
  }
  function randomHex(size) {
    var out = '';
    var values;
    if (window.crypto && window.crypto.getRandomValues) {
      values = new Uint8Array(size);
      window.crypto.getRandomValues(values);
      for (var i = 0; i < values.length; i++) {
        out += ('0' + values[i].toString(16)).slice(-2);
      }
      return out;
    }
    for (var j = 0; j < size; j++) {
      out += ('0' + Math.floor(Math.random() * 256).toString(16)).slice(-2);
    }
    return out;
  }
  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    var h = randomHex(16);
    return h.slice(0, 8) + '-' + h.slice(8, 12) + '-4' + h.slice(13, 16) + '-' +
      ((parseInt(h.slice(16, 18), 16) & 0x3f) | 0x80).toString(16) + h.slice(18, 20) + '-' + h.slice(20, 32);
  }
  function decodeCookieValue(value) {
    try {
      return decodeURIComponent(value);
    } catch (e) {
      return value;
    }
  }
  function cookieValue(name) {
    if (typeof document === 'undefined' || !document.cookie) return '';
    var cookies = String(document.cookie).split(';');
    var prefix = name + '=';
    for (var i = 0; i < cookies.length; i++) {
      var item = cookies[i].trim();
      if (item.indexOf(prefix) === 0) {
        return decodeCookieValue(item.slice(prefix.length));
      }
    }
    return '';
  }
  function getDeviceId() {
    var shopifyDeviceId = cookieValue('_shopify_y');
    if (shopifyDeviceId) return shopifyDeviceId;
    var id = storageGet(window.localStorage, deviceKey);
    if (!id) {
      id = uuid();
      storageSet(window.localStorage, deviceKey, id);
    }
    return id;
  }
  function parseJson(value) {
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  }
  function getSessionId() {
    var shopifySessionId = cookieValue('_shopify_s');
    if (shopifySessionId) return shopifySessionId;
    var now = Date.now();
    var raw = storageGet(window.localStorage, sessionKey);
    var cached = parseJson(raw);
    if (cached && cached.id && cached.lastSeen && now - Number(cached.lastSeen) <= sessionTtlMs) {
      storageSet(window.localStorage, sessionKey, JSON.stringify({ id: cached.id, lastSeen: now }));
      return cached.id;
    }
    var id = raw && raw.charAt(0) !== '{' ? raw : storageGet(window.sessionStorage, sessionKey);
    if (!id || id.charAt(0) === '{') {
      id = uuid();
    }
    storageSet(window.localStorage, sessionKey, JSON.stringify({ id: id, lastSeen: now }));
    return id;
  }
  function deviceType() {
    var w = window.innerWidth || document.documentElement.clientWidth || 0;
    if (w < 768) return 'mobile';
    if (w < 1024) return 'tablet';
    return 'desktop';
  }
  function pageType() {
    return cfg.pageType || (document.body && document.body.className ? String(document.body.className).split(' ')[0] : '');
  }
  function baseProps(extra, rawPageUrl) {
    var props = {
      shopify_theme_id: window.Shopify && Shopify.theme ? String(Shopify.theme.id || '') : '',
      shopify_theme_name: window.Shopify && Shopify.theme ? String(Shopify.theme.name || '') : '',
      page_template: cfg.pageTemplate || '',
      currency: cfg.currency || '',
      source: 'blingflare-theme'
    };
    var tracking = trackingParams(rawPageUrl || location.href);
    if (Object.keys(tracking).length) {
      props.tracking_params = tracking;
    }
    if (extra) {
      for (var k in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, k) && extra[k] !== undefined) {
          props[k] = extra[k];
        }
      }
    }
    return props;
  }
  function isTrackingParam(key) {
    var lower = String(key || '').toLowerCase();
    var fixed = {
      fbclid: true,
      gclid: true,
      msclkid: true,
      mc_eid: true,
      _ga: true,
      _gl: true,
      // 2026-07-03 真实广告流量实测缺口:Meta 注入 campaign_id/ad_id/adset_id、
      // Google Ads 注入 gad_source/gad_campaignid、Google 购物注入 srsltid,
      // 漏剥会把同一页按参数组合裂成多个 idp_page(与服务端 IdpUtils 黑名单保持同步)
      campaign_id: true,
      ad_id: true,
      adset_id: true,
      gad_source: true,
      gad_campaignid: true,
      srsltid: true,
      // idp_page 全量参数盘点补:Shopify 搜索归因/_推荐位归因/货币插件计数/联盟归因
      _pos: true,
      _sid: true,
      _ss: true,
      _psq: true,
      pr_prod_strat: true,
      pr_rec_id: true,
      pr_rec_pid: true,
      pr_ref_pid: true,
      pr_seq: true,
      stkn: true,
      sub_id: true
    };
    return lower.indexOf('utm_') === 0 || fixed[lower];
  }
  function fnv1a(input) {
    var hash = 2166136261;
    input = String(input || '');
    for (var i = 0; i < input.length; i++) {
      hash ^= input.charCodeAt(i);
      hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
    }
    return hash >>> 0;
  }
  function normalizeAllocation(value) {
    var num = Number(value || 0);
    if (!isFinite(num) || num <= 0) return 0;
    return num <= 1 ? Math.round(num * 1000) : Math.round(num);
  }
  function pickVariant(experiment) {
    var variants = experiment && experiment.variants;
    if (!variants || !variants.length) return null;
    var bucket = fnv1a(getDeviceId() + ':' + experiment.experimentKey) % 1000;
    var cursor = 0;
    for (var i = 0; i < variants.length; i++) {
      cursor += normalizeAllocation(variants[i].allocation);
      if (bucket < cursor) return variants[i];
    }
    return null;
  }
  function currentAssignments() {
    var experiments = experimentConfig && experimentConfig.experiments;
    var assignments = [];
    if (!experiments || !experiments.length) return assignments;
    experiments.forEach(function (experiment) {
      if (!experiment || !experiment.experimentKey) return;
      var variant = pickVariant(experiment);
      if (!variant || !variant.variantKey) return;
      assignments.push({
        experimentKey: experiment.experimentKey,
        variantKey: variant.variantKey
      });
    });
    return assignments;
  }
  function exposureStorageKey(assignment) {
    return 'idp_exp_exposed_' + webKey + '_' + getDeviceId() + '_' + assignment.experimentKey;
  }
  function emitExposures(assignments) {
    assignments.forEach(function (assignment) {
      var key = exposureStorageKey(assignment);
      if (storageGet(window.localStorage, key)) return;
      storageSet(window.localStorage, key, assignment.variantKey);
      enqueue('exposure', {
        experimentKey: assignment.experimentKey,
        variantKey: assignment.variantKey,
        props: {
          exposure_source: 'client_hash',
          experiment_assignments: [assignment]
        }
      }, false);
    });
  }
  function normalizeExperimentPayload(data) {
    var body = data && data.data ? data.data : data;
    if (body && body.result) body = body.result;
    if (!body || !body.experiments) return null;
    return {
      webKey: body.webKey || webKey,
      experiments: body.experiments || []
    };
  }
  function loadCachedExperimentConfig() {
    var cached = parseJson(storageGet(window.localStorage, expConfigKey));
    if (!cached || !cached.ts || Date.now() - cached.ts > expConfigTtlMs) return;
    experimentConfig = cached.config || null;
  }
  function fetchExperimentConfig() {
    if (!enabled || !window.fetch || !experimentEndpoint) return;
    fetch(experimentEndpoint, {
      method: 'GET',
      credentials: 'omit',
      cache: 'force-cache'
    }).then(function (res) {
      if (!res || !res.ok) return null;
      return res.json();
    }).then(function (data) {
      var config = normalizeExperimentPayload(data);
      if (!config) return;
      experimentConfig = config;
      storageSet(window.localStorage, expConfigKey, JSON.stringify({
        ts: Date.now(),
        config: config
      }));
      emitExposures(currentAssignments());
      flush(false);
    }).catch(function () {
      // experiment config is optional in v1; tracking still works without it
    });
  }
  function trackingParams(url) {
    var result = {};
    try {
      var query = new URL(url).searchParams;
      query.forEach(function (value, key) {
        var lower = String(key).toLowerCase();
        if (isTrackingParam(lower)) {
          result[lower] = value;
        }
      });
    } catch (e) {
      // ignore malformed URL
    }
    return result;
  }
  function normalizeUrl(url) {
    try {
      var parsed = new URL(url, location.href);
      var remove = [];
      parsed.searchParams.forEach(function (_value, key) {
        if (isTrackingParam(key)) remove.push(key);
      });
      remove.forEach(function (key) {
        parsed.searchParams.delete(key);
      });
      parsed.hash = '';
      return parsed.toString();
    } catch (e) {
      return url;
    }
  }
  function buildEvent(name, extra) {
    extra = extra || {};
    var rawPageUrl = extra.pageUrl || location.href;
    return {
      eventId: extra.eventId || uuid(),
      eventName: name,
      ts: extra.ts || Date.now(),
      deviceId: getDeviceId(),
      sessionId: getSessionId(),
      customerId: cfg.customerId || '',
      pageUrl: normalizeUrl(rawPageUrl),
      referrer: document.referrer || '',
      pageType: extra.pageType || pageType(),
      pageTitle: extra.pageTitle || document.title,
      deviceType: extra.deviceType || deviceType(),
      viewportW: window.innerWidth || document.documentElement.clientWidth || 0,
      elementSelector: extra.elementSelector,
      elementText: extra.elementText,
      xPct: extra.xPct,
      yPct: extra.yPct,
      scrollDepth: extra.scrollDepth,
      engagementMs: extra.engagementMs,
      experimentKey: extra.experimentKey,
      variantKey: extra.variantKey,
      props: baseProps(extra.props, rawPageUrl)
    };
  }
  function enqueue(name, extra, immediate) {
    if (!enabled) return;
    queue.push(buildEvent(name, extra));
    if (queue.length >= maxBatchSize || immediate) {
      flush(false);
    }
  }
  function payload(events) {
    return JSON.stringify({
      webKey: webKey,
      events: events
    });
  }
  function saveDeadLetter(events, attempts) {
    if (!events || !events.length) return;
    var list = [];
    try {
      list = JSON.parse(storageGet(window.localStorage, deadLetterKey) || '[]') || [];
    } catch (e) {
      list = [];
    }
    list.push({
      attempts: attempts || 0,
      nextAt: Date.now() + retryDelay(attempts || 0),
      events: events
    });
    try {
      var trimmed = list.slice(-20);
      var droppedOverflow = trimmed.length < list.length;
      if (droppedOverflow) {
        recordDeadLetterDrop(list.slice(0, list.length - trimmed.length), 'overflow');
      }
      window.localStorage.setItem(deadLetterKey, JSON.stringify(trimmed));
      if (droppedOverflow) {
        sendHeartbeat(true);
      }
    } catch (e2) {
      recordDeadLetterDrop([{ events: events }], 'storage_unavailable');
      sendHeartbeat(true);
    }
  }
  function retryDelay(attempts) {
    var delays = [60000, 300000, 1800000, 7200000];
    return delays[Math.min(attempts, delays.length - 1)];
  }
  function sendFetch(events) {
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: payload(events),
      keepalive: true,
      credentials: 'omit'
    }).then(function (res) {
      if (!res || res.status === 408 || res.status === 429 || res.status >= 500) {
        throw new Error('idp-events HTTP ' + (res && res.status));
      }
    });
  }
  function countEvents(batches) {
    var total = 0;
    (batches || []).forEach(function (batch) {
      total += batch && batch.events ? batch.events.length : 0;
    });
    return total;
  }
  function recordDeadLetterDrop(batches, reason) {
    var dropped = countEvents(batches);
    if (!dropped) return;
    deadLetterDropped += dropped;
    if (window.console && console.warn) {
      console.warn('[idp-events] dead-letter dropped', { webKey: webKey, dropped: dropped, reason: reason });
    }
  }
  function deadLetterPendingCount() {
    var raw = storageGet(window.localStorage, deadLetterKey);
    var list = parseJson(raw) || [];
    return countEvents(list);
  }
  function sendHeartbeat(force) {
    if (!enabled || !heartbeatEndpoint || !window.fetch) return;
    var now = Date.now();
    if (!force && now - lastHeartbeatAt < heartbeatIntervalMs) return;
    var report = {
      webKey: webKey,
      deadLetterPending: deadLetterPendingCount(),
      deadLetterDropped: deadLetterDropped,
      queueDepth: queue.length
    };
    if (!force && !report.deadLetterPending && !report.deadLetterDropped && !report.queueDepth) {
      lastHeartbeatAt = now;
      return;
    }
    lastHeartbeatAt = now;
    fetch(heartbeatEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify(report),
      keepalive: true,
      credentials: 'omit'
    }).then(function (res) {
      if (res && res.status < 500) {
        deadLetterDropped = 0;
      }
    }).catch(function () {
      // heartbeat must not create another dead-letter loop
    });
  }
  function flush(useBeacon) {
    if (!enabled || !queue.length) return;
    var events = queue.splice(0, maxBatchSize);
    if (useBeacon && navigator.sendBeacon) {
      try {
        if (navigator.sendBeacon(endpoint, new Blob([payload(events)], { type: 'text/plain;charset=UTF-8' }))) {
          return;
        }
      } catch (e) {
        // fall through to fetch
      }
    }
    sendFetch(events).catch(function () {
      saveDeadLetter(events, 0);
    });
  }
  function drainDeadLetter() {
    if (!enabled) return;
    var raw = storageGet(window.localStorage, deadLetterKey);
    if (!raw) return;
    var list;
    try {
      list = JSON.parse(raw) || [];
    } catch (e) {
      storageSet(window.localStorage, deadLetterKey, '[]');
      return;
    }
    var now = Date.now();
    var keep = [];
    var hasDropped = false;
    list.forEach(function (batch) {
      if (!batch || !batch.events) return;
      if (batch.attempts >= 5) {
        recordDeadLetterDrop([batch], 'max_attempts');
        hasDropped = true;
        return;
      }
      if (batch.nextAt && batch.nextAt > now) {
        keep.push(batch);
        return;
      }
      sendFetch(batch.events).catch(function () {
        batch.attempts = (batch.attempts || 0) + 1;
        batch.nextAt = Date.now() + retryDelay(batch.attempts);
        saveDeadLetter(batch.events, batch.attempts);
      });
    });
    storageSet(window.localStorage, deadLetterKey, JSON.stringify(keep));
    sendHeartbeat(hasDropped);
  }
  function escAttr(v) {
    return String(v).replace(/"/g, '\\"').slice(0, 120);
  }
  // B' 商品卡片：/products/<handle> 锚点 → 稳定 handle 选择器（survives variant 参数 / 主题改版）
  function productHandleSelector(el) {
    if (!el || el.tagName !== 'A') return '';
    var href = el.getAttribute('href') || '';
    var m = href.match(/\/products\/([^/?#]+)/);
    if (m && m[1]) return 'a[href*="/products/' + m[1].replace(/"/g, '').slice(0, 80) + '"]';
    return '';
  }
  // 采集白名单（柴进 2026-07-02 拍板）：优先产出 A(id)/B(destFunction)/B'(products)/aria-label/title/data-track-name
  // 这 6 类稳定选择器；交互元素允许最后一档受控结构兜底，非交互元素仍返 null。
  // resolveSelector 是唯一闸门，closestTrackEl 与 bindClicks 共用，杜绝脆弱选择器污染 element_selector 维度。
  //
  // 2026-08-31 修正：人工埋点 data-destfunctionbutton 排到 id 之前。同一元素两者并存时，埋点是运营写的
  // 语义标签，id 多是 Shopify 自动生成的随机串（picture-image_3JdNMU、...__slideshow_jdJ6pQ），
  // 改版即漂移；语义优先于自动 id。
  //
  // 属性名一律小写：HTML 解析器把属性名强制小写（页面实测 getAttributeNames() 只有
  // data-destfunctionbutton），getAttribute 与 CSS 属性选择器在 HTML 文档里本就大小写不敏感，
  // 写哪种都取得到。但**生成的 selector 字符串会进 idp_element.selector_hash（sha256 原串）**，
  // 大小写一变 hash 就变 → 同一个按钮裂成两条维表行、聚合 PV/UV 被拆。
  // prod 实测已裂 3915 个标签（FG 上驼峰版与小写版 SDK 同时在跑）。统一小写 = 对齐 DOM 真实形态。
  // ⚠️ 只统一 DOM 属性名；bbQfetch 收的是 JS 对象（驼峰 key），大小写敏感，不许跟着改。
  var INTERACTIVE_TAGS = { A: 1, BUTTON: 1, INPUT: 1, SELECT: 1, TEXTAREA: 1, SUMMARY: 1, LABEL: 1 };
  var STATE_CLASSES = {
    active: 1, selected: 1, open: 1, show: 1, hidden: 1, current: 1, disabled: 1
  };
  var MAX_CONTAINER_DEPTH = 3;
  // FG prod 67% 点击已落到 id，其中远容器还会把 JSON-LD 当文本；单个容器一天 2149 次说明
  // “找不到近处标识就继续爬”不是缺采而是错归因。交互元素必须在源头形成可回查的稳定主体。
  function interactiveFallbackSelector(el) {
    if (!INTERACTIVE_TAGS[el.tagName]) return '';
    var ownSelector = el.tagName.toLowerCase();
    var name = el.getAttribute('name');
    if (name) {
      ownSelector += '[name="' + escAttr(name) + '"]';
    } else {
      var classes = String(el.className || '').split(/\s+/);
      for (var i = 0; i < classes.length; i++) {
        var className = classes[i];
        var lower = className.toLowerCase();
        if (!className || lower.indexOf('is-') === 0 || lower.indexOf('has-') === 0 || STATE_CLASSES[lower]) continue;
        if (/^-?[_a-zA-Z]+[_a-zA-Z0-9-]*$/.test(className) && ownSelector.length + className.length + 1 <= 200) {
          ownSelector += '.' + className;
        }
        break;
      }
    }
    var section = el.closest && el.closest('[id^="shopify-section"], [id^="sections--"]');
    if (section && section.id) {
      var scopedSelector = '#' + section.id + ' ' + ownSelector;
      // 截断会制造 querySelector 查不回的半截选择器；异常超长 section id 时退回元素自身更诚实。
      if (scopedSelector.length <= 200) return scopedSelector;
    }
    return ownSelector;
  }
  function resolveSelector(el) {
    if (!el || el.nodeType !== 1) return null;
    var label = el.getAttribute('data-destfunctionbutton');
    if (label) return { sel: '[data-destfunctionbutton="' + escAttr(label) + '"]', strategy: 'destFunction' };
    if (el.id) return { sel: '#' + el.id, strategy: 'id' };
    var prod = productHandleSelector(el);
    if (prod) return { sel: prod, strategy: 'products' };
    var aria = el.getAttribute('aria-label');
    if (aria) return { sel: '[aria-label="' + escAttr(aria) + '"]', strategy: 'aria-label' };
    var title = el.getAttribute('title');
    if (title) return { sel: '[title="' + escAttr(title) + '"]', strategy: 'title' };
    var trackName = el.getAttribute('data-track-name');
    if (trackName) return { sel: '[data-track-name="' + escAttr(trackName) + '"]', strategy: 'data-track-name' };
    var interactiveFallback = interactiveFallbackSelector(el);
    if (interactiveFallback) return { sel: interactiveFallback, strategy: 'interactive-fallback' };
    return null;
  }
  // 这次点击的"语义主体"：运营埋点元素，或浏览器意义上真正被点的交互元素，或带无障碍语义的元素。
  // 纯布局容器（一个自动 id 的 div/picture/section）不是主体，只能当兜底。
  function isSemanticSubject(el) {
    if (el.getAttribute('data-destfunctionbutton')) return true;
    if (INTERACTIVE_TAGS[el.tagName]) return true;
    return !!(el.getAttribute('aria-label') || el.getAttribute('title') || el.getAttribute('data-track-name'));
  }
  // 命中判据（谁是主体）与 selector 生成（怎么表达它）是两件事，旧实现混在 resolveSelector 一个函数里：
  // 自底向上第一个有 id 的元素就停，于是 FG 首页 slideshow 的 <picture id="picture-image_3JdNMU">
  // 截胡了外层 <a data-destfunctionbutton="slideshow轮播图:第2张">，点击全落成 #picture-image_xxx +
  // 空 text_preview（prod 实证 idp_element 14680），埋点永远进不了 destFunction 下拉。
  // 修法：向上找第一个语义主体；纯容器 id 只在近距离记为 fallback，避免远容器伪造归因。
  function closestTrackEl(target) {
    var el = target;
    var fallback = null;
    var depth = 0;
    while (el && el !== document && el.nodeType === 1) {
      if (resolveSelector(el)) {                 // 命中白名单（可产出稳定 selector）
        if (isSemanticSubject(el)) return el;
        // 远容器已在 FG 把 67% 的 id 点击放大成噪音；只保留近处兜底，主体搜索仍可继续向上。
        if (!fallback && depth <= MAX_CONTAINER_DEPTH) fallback = el;
      }
      el = el.parentElement;
      depth += 1;
    }
    return fallback;   // 没有主体和近距离容器 → 丢弃整个 click，不再 fallback 到 raw target
  }
  function elementText(el) {
    if (!el) return '';
    return el.getAttribute('data-destfunctionbutton') ||
      el.getAttribute('aria-label') ||
      el.getAttribute('title') ||
      el.getAttribute('data-track-name') ||
      (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 30);
  }
  // selector 是 resolveSelector 的薄封装（非交互白名单外返 ''）。
  function selector(el) {
    var r = resolveSelector(el);
    return r ? r.sel : '';
  }
  function listIncludes(list, value) {
    if (!list) return false;
    if (typeof list === 'string') return list === value;
    if (!list.length) return false;
    for (var i = 0; i < list.length; i++) {
      if (list[i] === value) return true;
    }
    return false;
  }
  function inspectorOriginAllowed(origin) {
    return listIncludes(inspectorAllowedOrigins, origin);
  }
  function viewportSnapshot() {
    return {
      width: window.innerWidth || document.documentElement.clientWidth || 0,
      height: window.innerHeight || document.documentElement.clientHeight || 0,
      scrollX: window.pageXOffset || document.documentElement.scrollLeft || 0,
      scrollY: window.pageYOffset || document.documentElement.scrollTop || 0
    };
  }
  function inspectSelector(rawSelector, highlight) {
    var result = {
      selector: rawSelector,
      found: false
    };
    var el;
    try {
      el = document.querySelector(rawSelector);
    } catch (e) {
      result.error = 'invalid_selector';
      return result;
    }
    if (!el) return result;
    var rect = el.getBoundingClientRect();
    var viewport = viewportSnapshot();
    if (highlight) {
      highlightElement(el);
    }
    return {
      selector: rawSelector,
      found: true,
      tagName: el.tagName ? el.tagName.toLowerCase() : '',
      text: elementText(el),
      href: el.href || '',
      rect: {
        left: Math.round(rect.left),
        top: Math.round(rect.top),
        width: Math.round(rect.width),
        height: Math.round(rect.height),
        xPct: viewport.width ? Math.round(((rect.left + rect.width / 2) / viewport.width) * 10000) / 100 : 0,
        yPct: viewport.height ? Math.round(((rect.top + rect.height / 2) / viewport.height) * 10000) / 100 : 0
      }
    };
  }
  function highlightElement(el) {
    var previousOutline = el.style.outline;
    var previousBoxShadow = el.style.boxShadow;
    el.style.outline = '2px solid #ff4d4f';
    el.style.boxShadow = '0 0 0 4px rgba(255,77,79,0.18)';
    setTimeout(function () {
      el.style.outline = previousOutline;
      el.style.boxShadow = previousBoxShadow;
    }, 2500);
  }
  function bindInspector() {
    if (!window.addEventListener || window.parent === window) return;
    window.addEventListener('message', function (event) {
      var data = event.data;
      if (typeof data === 'string') data = parseJson(data);
      if (!data || data.source !== 'idp-admin-heatmap' || data.type !== 'IDP_HEATMAP_INSPECT') return;
      if (!inspectorOriginAllowed(event.origin)) return;
      var selectors = Array.isArray(data.selectors) ? data.selectors.slice(0, 100) : [];
      var elements = selectors.map(function (item) {
        return inspectSelector(String(item || ''), data.highlight === true);
      });
      event.source.postMessage({
        source: 'idp-events-sdk',
        type: 'IDP_HEATMAP_INSPECT_RESULT',
        requestId: data.requestId || '',
        webKey: webKey,
        pageUrl: normalizeUrl(location.href),
        viewport: viewportSnapshot(),
        elements: elements
      }, event.origin);
    });
  }
  // 坐标参照系 = 被点元素自身（(clickX-rect.left)/rect.width），设备/滚动无关，
  // 回放时 selector→rect 即可还原;拿不到 rect 时返 null,不回落视口坐标（两代语义禁混存）
  function clickPosition(e, el) {
    var rect = el && el.getBoundingClientRect ? el.getBoundingClientRect() : null;
    if (!rect || !rect.width || !rect.height) {
      return { xPct: null, yPct: null };
    }
    var xPct = (((e.clientX || 0) - rect.left) / rect.width) * 100;
    var yPct = (((e.clientY || 0) - rect.top) / rect.height) * 100;
    return {
      xPct: Math.round(Math.min(100, Math.max(0, xPct)) * 100) / 100,
      yPct: Math.round(Math.min(100, Math.max(0, yPct)) * 100) / 100
    };
  }
  function bindClicks() {
    document.addEventListener('click', function (e) {
      var el = closestTrackEl(e.target);
      if (!el) return;                       // 白名单外（C/D）→ 不采
      var resolved = resolveSelector(el);
      var pos = clickPosition(e, el);
      enqueue('click', {
        elementSelector: resolved.sel,
        elementText: elementText(el),
        xPct: pos.xPct,
        yPct: pos.yPct,
        props: {
          href: el.href || '',
          semantic_source: resolved.strategy
        }
      });
    }, true);
  }
  // 询单事件（inquiry_open）：contact 表单提交 = 询单意向。document 捕获阶段委托监听 submit
  // （防表单自身 stopPropagation 吞事件）。判据：form 内 Shopify {% form 'contact' %} 自动渲染的
  // 隐藏域 input[name="form_type"] 值 === 'contact'，覆盖 sections/contact-form.liquid（联系页表单）
  // 与 snippets/ask-question-form.liquid（PDP 问商品表单）两处；newsletter-form 是 {% form 'customer' %}
  // （form_type=customer）不命中。同一 form 3 秒防重（防慢网双击；Shopify 提交跳页，标记自然失效）。
  function inquiryFormType(form) {
    if (!form || !form.querySelector) return '';
    var input = form.querySelector('input[name="form_type"]');
    return input ? String(input.value || '') : '';
  }
  function bindInquiry() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (inquiryFormType(form) !== 'contact') return;
      // submit 原生事件本身在 HTML5 校验通过后才触发，这里防御 novalidate 表单场景
      if (form.checkValidity && !form.checkValidity()) return;
      var now = Date.now();
      if (form.__idpInquiryTs && now - form.__idpInquiryTs < 3000) return;
      form.__idpInquiryTs = now;
      var resolved = resolveSelector(form);
      enqueue('inquiry_open', {
        elementSelector: resolved ? resolved.sel : '',
        elementText: elementText(form),
        props: {
          semantic_source: resolved ? resolved.strategy : ''
        }
      }, true);
    }, true);
  }
  function pageKey() {
    return location.origin + location.pathname + location.search;
  }
  function trackPageView() {
    lastPageUrl = location.href;
    pageStartedAt = Date.now();
    scrollSent = {};
    var assignments = currentAssignments();
    emitExposures(assignments);
    var firstAssignment = assignments[0] || {};
    enqueue('page_view', {
      pageUrl: location.href,
      referrer: document.referrer || '',
      experimentKey: firstAssignment.experimentKey,
      variantKey: firstAssignment.variantKey,
      props: {
        history_state: history.state ? 'present' : 'empty',
        experiment_assignments: assignments
      }
    }, true);
  }
  function bindHistory() {
    ['pushState', 'replaceState'].forEach(function (name) {
      var original = history[name];
      if (typeof original !== 'function') return;
      history[name] = function () {
        var ret = original.apply(this, arguments);
        setTimeout(function () {
          if (location.href !== lastPageUrl) trackPageView();
        }, 0);
        return ret;
      };
    });
    window.addEventListener('popstate', function () {
      setTimeout(function () {
        if (location.href !== lastPageUrl) trackPageView();
      }, 0);
    });
  }
  function bindScroll() {
    window.addEventListener('scroll', function () {
      var doc = document.documentElement;
      var body = document.body;
      var scrollTop = window.pageYOffset || doc.scrollTop || body.scrollTop || 0;
      var height = Math.max(body.scrollHeight, doc.scrollHeight) - window.innerHeight;
      if (height <= 0) return;
      var depth = Math.floor((scrollTop / height) * 100);
      [25, 50, 75, 100].forEach(function (bucket) {
        var key = pageKey() + ':' + bucket;
        if (depth >= bucket && !scrollSent[key]) {
          scrollSent[key] = true;
          enqueue('scroll', { scrollDepth: bucket }, false);
        }
      });
    }, { passive: true });
  }
  function trackEngagement(useBeacon) {
    var ms = Date.now() - pageStartedAt;
    if (ms < 1000) return;
    enqueue('engagement_time', { engagementMs: ms }, false);
    flush(useBeacon);
    pageStartedAt = Date.now();
  }
  function bindLifecycle() {
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        trackEngagement(true);
      } else if (document.visibilityState === 'visible') {
        pageStartedAt = Date.now();
      }
    });
    window.addEventListener('pagehide', function () {
      trackEngagement(true);
      sendHeartbeat(true);
    });
  }
  // legacy 埋点 shim 已下线（2026-08-31，柴进拍板）。
  //
  // bbQfetch 是老埋点时代的手工打点函数，活动页在自己的 click handler 里手写一行调用。
  // 上了 v2 SDK 之后 bindClicks 已经在 document 捕获阶段自动采同一次点击，两者完全重叠：
  // prod 近 7 天全量比对 799 条 legacy click，752 条（94%）能在同 device ±2s 内配对到
  // 一条自动采集的 click —— 同一次点击被记两次，点击量虚高。
  //
  // 这里保留空函数而不是整个删掉：仓外还有调用点（各站 whsection.js 是压缩产物、
  // Shopify 后台注入代码），直接删会让调用方抛 TypeError 中断它自己的后续逻辑。
  // 等调用点清干净了再整体移除这一行。
  window.bbQfetch = function () {};
  window.IdpEventsSDK = {
    track: enqueue,
    flush: function () { flush(false); },
    deviceId: getDeviceId,
    sessionId: getSessionId,
    inspectSelectors: function (selectors, options) {
      options = options || {};
      return (selectors || []).slice(0, 100).map(function (item) {
        return inspectSelector(String(item || ''), options.highlight === true);
      });
    }
  };
  if (enabled) {
    loadCachedExperimentConfig();
    bindClicks();
    bindInquiry();
    bindHistory();
    bindScroll();
    bindLifecycle();
    bindInspector();
    drainDeadLetter();
    fetchExperimentConfig();
    trackPageView();
    flushTimer = setInterval(function () {
      drainDeadLetter();
      flush(false);
      sendHeartbeat(false);
    }, flushIntervalMs);
    if (flushTimer && flushTimer.unref) flushTimer.unref();
  }
})();